<template>
	<app-page>
		<app-heading :title="isNew ? 'New Commission' : commission.source" />
		<app-form @submit="onSubmit">
			<app-section style="width: 800px;">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button
						type="cancel"
						small
						:to="{ name: 'integration-connection-child', params: {
							integration: integrationId,
							connection: connectionId,
							connectiontab: 'commissions',
						}}"
					>Cancel</app-button>
				</app-section-actions>
				<input-text
					type="text"
					label="Source (lower-case)"
					v-model="commission.source"
					:errors="errors.source"
					required
				/>
				<input-select
					label="Travel agents"
					multiple
					:items="travelAgents"
					v-model="commission.travel_agents"
					:errors="errors.travel_agents"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
import { mapSelectOptions, mapEntries } from '@/utils/maps'

export default {
	async created() {
		try {
			this.$store.dispatch('app/startLoading')

			if (this.id !== 'new') {
				const commission = await this.$ravello.request()
					.v(2)
					.to('integrations')
					.to(this.integrationId)
					.to('connections')
					.to(this.connectionId)
					.to('commissions')
					.to(this.id)
					.get()

				this.commission = {
					source: commission.source,
					travel_agents: commission.travel_agents,
				}
			}

			const resortsMap = mapEntries(await this.$ravello.request()
				.v(2)
				.to('resorts')
				.limit(100)
				.get())
			const travelAgents = (await this.$ravello.request()
				.v(2)
				.to('travelagents')
				.limit(10000)
				.sort('name')
				.get())

			this.travelAgents = mapSelectOptions(travelAgents.map(travelAgent => ({
				...travelAgent,
				group: resortsMap[travelAgent.resort].name,
			})), { group: 'group' })

			this.$store.dispatch('app/stopLoading')
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
	},
	data() {
		return {
			commission: {
				source: '',
				travel_agents: [],
			},
			travelAgents: [],
			errors: {},
		}
	},
	computed: {
		integrationId() {
			return this.$route.params.integration
		},
		connectionId() {
			return this.$route.params.connection
		},
		id() {
			return this.$route.params.commission
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('integrations')
						.to(this.integrationId)
						.to('connections')
						.to(this.connectionId)
						.to('commissions')
						.create(this.commission)
				} else {
					await this.$ravello.request().to('integrations')
						.v(2)
						.to(this.integrationId)
						.to('connections')
						.to(this.connectionId)
						.to('commissions')
						.to(this.id)
						.update(this.commission)
				}
				this.$store.dispatch('app/stopLoading')
				this.$router.push({
					name: 'integration-connection-child',
					params: {
						integration: this.integrationId,
						connection: this.connectionId,
						connectiontab: 'commissions',
					},
				})
				this.$notifications.pushAlert('success', `Commission successfully ${this.isNew ? 'added' : 'updated'}`)
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}

				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
